import * as yup from "yup";

export const validationRules = {
  name: yup
    .string()
    .nullable()
    .max(50, "Name cannot exceed 50 characters.")
    .required("This is a required field."),
  phone: yup
    .string()
    .nullable()
    .min(7, "Phone number must be at least 7 characters.")
    .required("This is a required field."),
  password: yup
    .string()
    .nullable()
    .min(8, "Password must be at least 8 characters.")
    .required("This is a required field."),
  // .matches(
  //   /((?=.*[a-zA-Z]){1})((?=.*[A-Z]){1})/,
  //   "Password must contains at least one uppercase and lowercase character."
  // )
  // .matches(
  //   /((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-zA-Z]){1}).*$/,
  //   "Password must contain characters, numbers, and symbols. "
  // ),
  confirmPassword: yup
    .string()
    .nullable()
    .oneOf([yup.ref("password")], "Passwords do not match.")
    .required("This is a required field."),
  passwordLogin: yup.string().required("This is a required field."),
  email: yup
    .string()
    .nullable()
    .email("Please enter a valid email.")
    .required("This is a required field."),
  confirmEmail: yup
    .string()
    .nullable()
    .oneOf([yup.ref("email")], "Email does not match.")
    .required("This is a required field."),
  otp: yup
    .string()
    .nullable()
    .min(4, "OTP code must be 4 characters.")
    .required("This is a required field."),
};
